import { z } from 'zod';
import { isPhone, isName } from '@upstart/harmony/lib/validation/common.js';

const emailValidationMessage = 'Enter a valid email address';
export const emailSchema = z
  .string({ required_error: emailValidationMessage })
  .email({ message: emailValidationMessage });

const zipCodeRegExp = /^\d{5}(?:[-\s]\d{4})?$/;
export const zipSchema = z
  .string()
  .regex(zipCodeRegExp, 'Valid zip code is required');

export const phoneSchema = z
  .string()
  .refine(isPhone, 'Enter a valid phone number');

export const firstNameSchema = z
  .string()
  .refine(isName, 'Enter a valid first name');
export const lastNameSchema = z
  .string()
  .refine(isName, 'Enter a valid last name');
export const middleNameSchema = z
  .string()
  .refine(isName, 'Enter a valid middle name');

export const optionalPhoneSchema = makeSchemaOptional(phoneSchema);

export const requiredFieldSchema = z.string().min(1, 'This field is required');

export function makeSchemaOptional<T extends z.ZodType<string>>(
  schema: T,
): z.ZodUnion<[T, z.ZodLiteral<''>]> {
  return schema.or(z.literal(''));
}
export const optionalBooleanSchema = z.boolean().optional();
export const optionalStringSchema = makeSchemaOptional(z.string());
export const optionalFirstNameSchema = makeSchemaOptional(firstNameSchema);
export const optionalMiddleNameSchema = makeSchemaOptional(middleNameSchema);
export const optionalLastNameSchema = makeSchemaOptional(lastNameSchema);
export const optionalEmailSchema = makeSchemaOptional(emailSchema);
export const optionalIdSchema = z.string().or(z.number()).optional();
export const optionalZipSchema = makeSchemaOptional(zipSchema);
